import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type {
  BulkActionCustomListCustomPropertyOptionReorder,
  BulkActionResponseIncludesCustomPropertyInfo,
  BulkActionType,
} from 'donor-elf-web/models/bulk-action';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  propertyInfo: ContactCustomPropertyInfo;
  onGoBack: () => void;
  onClose: () => void;
}

export default class ContactDetailsPropertiesCustomPropertyEditOptionsModalReorderComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    this.options = args.propertyInfo.o!;
  }

  @service declare contactsCache: ContactsCache;

  bulkActionType: BulkActionType = 'custom_property_list_option_reorder';
  @tracked bulkActionCustom?: BulkActionCustomListCustomPropertyOptionReorder;

  @tracked saving = false;
  @tracked saveError = false;

  @tracked options: string[] = [];

  @action
  moveDown(index: number) {
    if (index < this.options.length - 1) {
      let temp = this.options[index];
      this.options[index] = this.options[index + 1];
      this.options[index + 1] = temp;
    }
    this.options = this.options;
  }

  @action
  moveUp(index: number) {
    if (index > 0) {
      let temp = this.options[index];
      this.options[index] = this.options[index - 1];
      this.options[index - 1] = temp;
    }
    this.options = this.options;
  }

  @action
  async save() {
    this.bulkActionCustom = {
      property_label: this.args.propertyInfo.l,
      options: this.options,
    };
    this.saving = true;
  }

  @action
  async onCompleted(response: BulkActionResponseIncludesCustomPropertyInfo) {
    let updatedCustomPropertyInfo = response.custom_property_info;
    if (updatedCustomPropertyInfo) {
      this.contactsCache.updateCustomPropertyInfo(updatedCustomPropertyInfo);
    }
    this.args.onClose();
  }

  @action
  onError() {
    this.saveError = true;
  }
}
